import * as requestFromServer from "./categoriesApis";
import Actions from "../../actions";
import { toastService } from "../../../component/common/toast-messages/toast";

// categories -> get categories select list api
export const getCategoriesSelectListAction =
  (setSelectListLoader, selectedLanguage) => async (dispatch) => {
    setSelectListLoader(true);
    const response = await requestFromServer.getCategoriesSelectList(selectedLanguage);
    if (response) {
      dispatch(
        Actions.createAction(Actions.GET_CATEGORIES_SELECT_LIST, {
          categoriesSelectList: response,
        })
      );
      setSelectListLoader(false);
      return response;
    } else {
      setSelectListLoader(false);
      return null;
    }
  };

//

// faqs -> get faqs api
export const getCategoriesAction = (dataToBeSent) => async (dispatch) => {
  const response = await requestFromServer.getCategories(dataToBeSent);
  if (response) {
    dispatch(
      Actions.createAction(Actions.GET_CATEGORIES_LIST, {
        categories: response,
      })
    );
    return response;
  }
};

// faqs -> create faqs api
export const createCategoryAction = (dataToBeSent) => async (dispatch) => {
  const response = await requestFromServer.createCategory(dataToBeSent);
  if (response) {
    toastService.success(response?.data?.message);
    return response;
  }
};

// faqs -> get faq by id api
export const getCategoryByIdAction = (dataToBeSent) => async (dispatch) => {
  const response = await requestFromServer.getCategoryById(dataToBeSent);
  if (response) {
    dispatch(
      Actions.createAction(Actions.GET_CATEGORIES_BY_ID, { category: response })
    );
    return response;
  }
};

// faqs -> update faqs api
export const updateCategoryAction = (dataToBeSent) => async (dispatch) => {
  const response = await requestFromServer.updateCategory(dataToBeSent);
  if (response) {
    toastService.success(response?.message);
    return response;
  }
};

// faqs -> delete faq by id api
export const deleteCategoryByIdAction = (dataToBeSent) => async (dispatch) => {
  const response = await requestFromServer.deleteCategoryById(dataToBeSent);
  if (response) {
    toastService.success(response?.message);
    return response;
  }
};
